import ResetPasswordModule from '@/modules/reset-password';

export default ResetPasswordModule;
